import React, { useState, useEffect } from "react";
import { Modal, Row } from "react-bootstrap";
import { Button } from "reactstrap";
import axiosConn from "config/axiosConn";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { userLoggedOut, userLoggedIn } from "../../redux/auth/authSlice";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { useFacultyLoginMutation } from "../../redux/auth/authApi";
import { isCaptchaRelaxed } from "utils/captchaDemo";
const encryptPassword = (password) => {
  const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
  const encryptedPassword = CryptoJS.AES.encrypt(
    password,
    secretKey
  ).toString();
  return encryptedPassword;
};

const generateToken = () => {
  const timestamp = Date.now();
  const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
  const token = CryptoJS.AES.encrypt(`${timestamp}`, secret).toString();
  return token;
};

// Token validation function
const validateResponseToken = (responseToken, requestToken) => {
  //   alert("token is validations")
  //   console.log("crazy stuff is happening")
  try {
    const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
    const decrypted = CryptoJS.AES.decrypt(responseToken, secret).toString(
      CryptoJS.enc.Utf8
    );
    const timestamp = parseInt(decrypted);

    // Check if token is tampered with
    if (isNaN(timestamp)) {
      return false;
    }

    // Check if token is expired (50 seconds)
    const currentTime = Date.now();
    const timeDifference = currentTime - timestamp;
    console.log(timeDifference, "timeDifference crazy stuff is happening");
    return timeDifference <= 50000 && responseToken === requestToken;
  } catch (error) {
    return false;
  }
};

function FacultyLoginModel({ handleViewexit }) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [udise_id, setUdise_id] = useState("");
  const [secretToken, setSecretToken] = useState("");
  const [emailOrMobile, setEmailOrMobile] = useState("");
  const [login, { isSuccess, error }] = useFacultyLoginMutation();
  const [password, setPassword] = useState("");
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [operator, setOperator] = useState("+");
  const [userInput, setUserInput] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false); // Loading state for OTP
  const [otpSent, setOtpSent] = useState(false); // Track if OTP has been sent
  const [otpSent2, setOtpSent2] = useState(false); // Track if OTP has been sent
  const [captcha, setCaptcha] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [loginMode, setLoginMode] = useState("otp"); // "otp" or "password"
  const CAPTCHA_LENGTH = 6;
  const [timer, setTimer] = useState(0); // Timer state
  const [resendCount, setResendCount] = useState(0); // Track resend count
  const [showPassword, setShowPassword] = useState(false);
  const isCaptchaError = (message = "") => /captcha/i.test(message);
  const sanitizeCaptchaInput = (value) => value.replace(/[^A-Za-z0-9]/g, "").slice(0, CAPTCHA_LENGTH);
  const sanitizeUdise = (value) => value.replace(/\D/g, "").slice(0, 11);
  const sanitizeEmailOrMobile = (value) => value.replace(/[^A-Za-z0-9@._+-]/g, "").slice(0, 160);
  console.log(userData, "userData");

  const renderCaptcha = (captchaObj) => (
    <img src={captchaObj?.image} alt="captcha" style={{ height: "50px", borderRadius: "6px" }} />
  );

  const generateCaptcha = async () => {
    try {
      const response = await axiosConn("get", "captcha");
      setCaptcha(response?.data?.captcha || {});
      setCaptchaAnswer("");
    } catch (error) {
      toast.error("Failed to load CAPTCHA");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const Logout = async () => {
    try {
      const makeLogout = await fetch(
        `https://ecoclubs.education.gov.in/api/logout`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (makeLogout.ok) {
        //  toast.success("Logout Successfully");
      }
    } catch (error) {
      toast.error("Logout Failed");
      console.log(error);
    }
    dispatch(userLoggedOut());
  };

  const handlePasswordLogin = async (e) => {
    e.preventDefault();

    if (!udise_id || !emailOrMobile || !password) {
      toast.error("Please fill all fields");
      return;
    }

    if (!isCaptchaRelaxed() && (!captcha || !captchaAnswer || captchaAnswer.length < CAPTCHA_LENGTH)) {
      toast.error("Please complete the CAPTCHA");
      return;
    }
    try {
      const authToken = generateToken();
      let captchaId = captcha?.captchaId;
      let postData = {
        udise_id,
        emailOrMobile,
        password,
        captchaId,
        captchaAnswer,
        authToken,
      };

      const response = await axiosConn("post", "faculty-login-password", postData);

      if (response?.data?.success) {
        // Decrypt user data
        const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
        const bytes = CryptoJS.AES.decrypt(response.data.user, secretKey);
        const decryptedUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        // Dispatch user data to Redux
        dispatch(userLoggedIn({
          accessToken: response.data.accessToken,
          user: decryptedUser,
          lang: decryptedUser.lang || 'en-IN'
        }));

        toast.success("Logged in successfully!");
        localStorage.setItem("isLogin", true);
        setShow(false);
        handleViewexit();
        navigate("/faculty");
      } else {
        toast.error(response?.data?.message || "Login failed");
        generateCaptcha();
        setPassword("");
        setCaptchaAnswer("");
      }
    } catch (error) {
      const message = error?.response?.data?.message || "An error occurred while logging in";
      toast.error(message);
      generateCaptcha();
      if (!isCaptchaError(message)) {
        setPassword("");
      }
      setCaptchaAnswer("");
      console.error("Password login error:", error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.warning("Please send OTP first.");
      return;
    }
    if (!isCaptchaRelaxed() && (!captcha || !captchaAnswer || captchaAnswer.length < CAPTCHA_LENGTH)) {
      toast.error("Please complete the CAPTCHA");
      return;
    }
    try {
      const authToken = generateToken();
      let captchaId = captcha?.captchaId;
      let postData = {
        udise_id,
        emailOrMobile,
        activation_code: password,
        role: 3,
        activation_token: token,
        captchaId,
        captchaAnswer,
        authToken,
      };
      // await login(postData);

      const result = await login(postData);

      // Check if result has error or data is missing
      if (result?.error || !result?.data) {
        const message = result?.error?.data?.message || "An error occurred while logging in. Please try again.";
        toast.error(message);
        generateCaptcha();
        setCaptchaAnswer("");
        if (!isCaptchaError(message)) {
          await Logout();
          setPassword("");
          setEmailOrMobile("");
          setSecretToken("");
          setUdise_id("");
          setOtpSent(false);
        }
        return;
      }

      if (!validateResponseToken(result.data.authToken, authToken)) {
        throw new Error("Invalid or expired token in response");
      }

      if (result?.data?.success) {

        toast.success("Logged in successfully!");
        localStorage.setItem("isLogin", true);
        setShow(false);
        handleViewexit();

        // Check if user has password set
        const userHasPassword = result?.data?.user?.hasPassword;

        if (!userHasPassword) {
          // First time login - redirect to password creation
          toast.info("Please create a password for easier login next time!");
          navigate("/faculty/password", { state: { activationToken: token } });
        } else {
          // Regular login - go to faculty dashboard
          navigate("/faculty");
        }
      } else {
        const message = result?.data?.message || "Login failed. Please try again.";
        toast.error(message);
        generateCaptcha();
        setCaptchaAnswer("");
        if (!isCaptchaError(message)) {
          await Logout();
          setPassword("");
          setEmailOrMobile("");
          setSecretToken("");
          setUdise_id("");
          setOtpSent(false);
        }
      }
    } catch (error) {
      const message = error?.data?.message || error?.message || "Invalid or expired token in response";
      toast.error(message);
      setCaptchaAnswer("");
      generateCaptcha();
      if (!isCaptchaError(message)) {
        await Logout();
        setEmailOrMobile("");
        setSecretToken("");
        setPassword("");
        setUdise_id("");
        setOtpSent(false);
      }
      console.error("Login error:", error);
    }
  };
  // useEffect(() => {
  //     console.log(isSuccess, error);
  //     if (isSuccess && !error) {

  //       toast.success("Logged in successfully!");
  //       localStorage.setItem("isLogin", true);
  //     setShow(false);
  //     handleViewexit();
  //     navigate("/faculty");
  //     }
  //     if (error) {
  //         // console.log(error)
  //         // toast.error(error.data.message)
  //       if ("data" in error) {
  //         const errorData = error ;
  //         toast.error(errorData.data.message);
  //         fetchCaptcha()
  //       }
  //     }
  //   }, [isSuccess, error]);

  // Function to start the timer
  const startTimer = (duration) => {
    setTimer(duration); // Set timer to the specified duration
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(interval); // Stop the timer when it reaches 0
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  const sendOTP = async (e) => {
    e.preventDefault();
    if (udise_id.length < 1) {
      toast.error("Please enter UDISE code");
      setLoading(false); // Stop loading
      return;
    } else if (udise_id.length !== 11) {
      setLoading(false); // Stop loading
      toast.error("Please enter a valid UDISE code.");
      return;
    }
    setLoading(true); // Start loading

    try {
      // Masking the email if emailOrMobile contains an email
      let maskedEmailOrMobile = emailOrMobile.includes("@")
        ? emailOrMobile.replace(
          /^(.)(.*)(@.*)$/,
          (match, first, middle, domain) => {
            return `${first}${"*".repeat(middle.length)}${domain}`;
          }
        )
        : emailOrMobile; // Keep mobile numbers unchanged

      let pass = encryptPassword(secretToken);

      let postData = { udise_id, emailOrMobile, role: 3, pass };

      let response = await axiosConn("post", "get-faculty-otp", postData);
      setLoading(false); // Stop loading

      if (response.data.success) {
        toast.success(
          `OTP sent successfully to ${maskedEmailOrMobile}! Please check your inbox.`
        );
        setToken(response.data.activationToken);
        setOtpSent(true); // Mark OTP as sent
        setOtpSent2(true); // Mark OTP as sent
        setResendCount((prevCount) => prevCount + 1); // Increment resend count
        const duration = 300; // Set duration based on resend count
        startTimer(duration); // Start the timer with the appropriate duration
      } else {
        toast.error("UDISE code incorrect. Please check the entered code.");
        generateCaptcha();
      }
    } catch (error) {
      setLoading(false); // Stop loading
      toast.error("An error occurred while sending OTP. Please try again.");
      generateCaptcha();
      console.error("Error sending OTP:", error);
    }
  };
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
        handleViewexit();
      }}
      className="loginmodal"
      enforceFocus={false}
    >
      <Modal.Body>
        <div className="popup-login-signup">
          <div className="login-box">
            <h3 className="text-center">FACULTY LOGIN</h3>
            <button
              type="button"
              className="popup-close-btn"
              onClick={() => {
                setShow(false);
                handleViewexit();
              }}
            >
              X
            </button>

            {/* Login Mode Toggle */}
            <div className="d-flex justify-content-center mb-3 mt-3">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${loginMode === 'otp' ? 'btn-success' : 'btn-outline-success'}`}
                  onClick={() => {
                    setLoginMode('otp');
                    setPassword("");
                    setSecretToken("");
                    setOtpSent(false);
                    generateCaptcha();
                  }}
                >
                  Login with OTP
                </button>
                <button
                  type="button"
                  className={`btn ${loginMode === 'password' ? 'btn-success' : 'btn-outline-success'}`}
                  onClick={() => {
                    setLoginMode('password');
                    setPassword("");
                    setSecretToken("");
                    setOtpSent(false);
                    generateCaptcha();
                  }}
                >
                  Login with Password
                </button>
              </div>
            </div>

            <form onSubmit={loginMode === 'otp' ? handleLogin : handlePasswordLogin}>
              <div className="form-group mt-3">
                <label htmlFor="udise_id" className="label-text">
                  UDISE Code
                </label>
                <input
                  autocomplete="off"
                  name="udise_id"
                  type="number"
                  className="form-input form-control"
                  placeholder="UDISE Code"
                  value={udise_id}
                  onChange={(e) => {
                    // Allow only numeric input and restrict length to 11
                    const value = sanitizeUdise(e.target.value);
                    if (value.length <= 11) {
                      // Restrict length to 11 digits
                      // setUsername(value);
                      setUdise_id(value);
                    }
                  }}
                  // onChange={(e) => }
                  required
                />
              </div>
              <div className="form-group mt-3">
                <label htmlFor="emailOrMobile" className="label-text">
                  Email or Mobile Number
                </label>
                <input
                  autocomplete="off"
                  name="emailOrMobile"
                  type="text"
                  className="form-input form-control"
                  placeholder="Enter Email or Mobile"
                  value={emailOrMobile}
                  onChange={(e) => setEmailOrMobile(sanitizeEmailOrMobile(e.target.value))}
                  maxLength={160}
                  required
                />
              </div>

              {/* Secret Token - Only for OTP mode */}
              {loginMode === 'otp' && (
                <>
                  <div className="form-group mt-3">
                    <label htmlFor="secretToken" className="label-text">
                      Secret Token
                    </label>
                    <input
                      autocomplete="off"
                      name="secretToken"
                      type="text"
                      className="form-input form-control"
                      placeholder="Enter Secret Token"
                      value={secretToken}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                        if (value.length <= 4) {
                          // Restrict to 4 digits
                          setSecretToken(value);
                        }
                      }}
                      required
                    />
                  </div>
                  <button
                    style={{ maxWidth: "150px", borderRadius: 5 }}
                    type="button"
                    className={`loginBtnnewhm mt-3 btn-sm mx-0 ${timer > 0 ? "disabled" : ""
                      }`}
                    onClick={sendOTP}
                    disabled={loading || timer > 0}
                  >
                    {loading
                      ? "Sending..."
                      : otpSent2
                        ? timer > 0
                          ? `Resend in ${formatTime(timer)}s`
                          : "Resend OTP"
                        : "Send OTP"}
                  </button>
                </>
              )}

              {/* Password/OTP Field */}
              <div className="form-group mt-3" style={{ position: "relative" }}>
                <label htmlFor="password" className="label-text">
                  {loginMode === 'otp' ? 'Enter The OTP Received' : 'Password'}
                </label>
                <input
                  autocomplete="off"
                  name="password"
                  type={loginMode === 'password' ? (showPassword ? 'text' : 'password') : 'text'}
                  required
                  placeholder={loginMode === 'otp' ? 'Enter Your OTP' : 'Enter Your Password'}
                  className="form-input form-control"
                  value={password}
                  onChange={(e) => {
                    if (loginMode === 'otp') {
                      const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                      if (value.length <= 4) {
                        // Restrict to 4 digits
                        setPassword(value);
                      }
                    } else {
                      // Password mode - allow any characters
                      setPassword(e.target.value.slice(0, 64));
                    }
                  }}
                  disabled={loginMode === 'otp' && !otpSent}
                  maxLength={loginMode === 'otp' ? 4 : 64} // Restrict length for both modes
                  inputMode={loginMode === 'otp' ? 'numeric' : 'text'} // Brings up a numeric keyboard on mobile devices
                />
                {loginMode === 'password' && (
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '15px',
                      bottom: '10px',
                      cursor: 'pointer',
                      zIndex: 10
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                )}
              </div>
              <div className="form-group mt-3">
                <div className="captcha-container">
                  {renderCaptcha(captcha)}
                  <div className="captcha-controls">
                    <input
                      type="text"
                      value={captchaAnswer}
                      onChange={(e) => setCaptchaAnswer(sanitizeCaptchaInput(e.target.value))}
                      placeholder="Enter the code"
                      maxLength={CAPTCHA_LENGTH}
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      className="captcha-refresh"
                      onClick={generateCaptcha}
                      title="Refresh CAPTCHA"
                    >
                      ↻
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-group mt-3">
                <Button type="submit" className="button green btn-login-signup">
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FacultyLoginModel;
